import EduCap from "../assets/images/education.svg";
import SSLC from "../assets/images/SSLC.png";
import HSC from "../assets/images/HSC.png";
import BE from "../assets/images/BE.jfif";

export const educationData = {
  title: "Education",
  description:
    "“Live as if you were to die tomorrow. Learn as if you were to live forever” – Mahatma Gandhi",
  image: EduCap,
  subTitle: "Degrees Received",
  data: [
    {
      id: 1,
      institution: "Unnamalai Institute of Technology, Kovilpatti.",
      course: "Electrical and Electronics Engineering",
      startYear: "2016",
      endYear: "2020",
      eduImg: BE,
    },
    {
      id: 2,
      institution: "Karapettai Nadar Hr. Sec. School, Thoothukudi.",
      course: "Higher Secondary Education",
      startYear: "2014",
      endYear: "2016",
      eduImg: HSC,
    },
    {
      id: 3,
      institution: "C.M.Hr.Sec.School, Thoothukudi.",
      course: "Secondary School Leaving Certificate",
      university: "Anna University",
      startYear: "2013",
      endYear: "2014",
      eduImg: SSLC,
    },
  ],
};
